import normalizeCustomerName from "./normalizeCustomerName"

const PREFIX = 'SDIRA'

const getSdiraBusinessName = (businessName) => {
  return normalizeCustomerName(`${PREFIX} ${businessName}`).toUpperCase()
}

export default getSdiraBusinessName
